class DailyBalanceSheetReportPrintController {
    /*@ngInject*/
    constructor($timeout, DailyBalanceSheetService, DateUtil) {
        this.$timeout = $timeout;
        this.DailyBalanceSheetService = DailyBalanceSheetService;
        this.DateUtil = DateUtil;
        this.printData = window.printData;

        this.loading = true;
        this.reportData = null;
    }

    $onInit() {
        if (!this.printData) {
            this.loading = false;
            return;
        }

        const { branch, fundingSourceId, currencyId, vaultDateRaw, branchTimezone } = this.printData;

        this.DailyBalanceSheetService.getVaultReportPrintData(branch, fundingSourceId, currencyId, vaultDateRaw, branchTimezone)
            .then(res => {
                if (res && res.data) {
                    this.reportData = res.data;
                }
                this.loading = false;

                this.$timeout(() => {
                    window.print();
                }, 500); // Give DOM time to render
            })
            .catch(err => {
                console.error("Error fetching vault report data:", err);
                this.loading = false;
            });
    }

    formatCurrency(amount, symbol = '$') {
        if (amount === undefined || amount === null || amount === '') {
            return '';
        }
        return `${symbol}${Number(amount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    }
}

export default DailyBalanceSheetReportPrintController;


// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/daily_balance_sheet/print/daily_balance_sheet_report/daily_balance_sheet_report_print.controller.js